import React from "react";
import get from "lodash/get";
import { object, bool, string } from "prop-types";
import { Link } from "@quintype/components";
import { PARTNER_CONTENT_STORY_TEMPLATE } from "../../../constants";
import { getStoryHeadline, getStoryLabel, isExternalStory } from "../../utils/story";
import { PublishAndReadTime } from "../../atoms/PublishAndReadTime";
import { HeroImage } from "../../atoms/HeroImage";
import { Label } from "../../atoms/Label";
import Headline from "../../atoms/Headline";

import "./three-col-nine-var-two.m.css";

export const VerticalStory = ({
  story,
  showThumbnail,
  showReadTime,
  showTimestamp,
  storySeperator,
  columnSeperator,
  defaultFallback,
  sectionSlug,
}) => {
  const sponsor = get(story, ["metadata", "sponsored-by"], null);
  const label = getStoryLabel(story);
  const imageUrl =
    get(story, ["hero-image-s3-key"], "") ||
    get(story, ["alternative", "home", "default", "hero-image", "hero-image-s3-key"], "");
  const isPartneredContent = story["story-template"] === PARTNER_CONTENT_STORY_TEMPLATE || sponsor !== null;
  const showImageThumbnail = (showThumbnail || isPartneredContent) && (imageUrl || defaultFallback);
  const headline = getStoryHeadline(story);
  const externalStoryUrl = isExternalStory(story);
  const href = externalStoryUrl ? externalStoryUrl : `/${story?.slug}`;
  const target = externalStoryUrl ? "_blank" : "_self";
  return (
    <div styleName={`vertical-story`} key={story.id} style={{ border: storySeperator || "none" }}>
      <Link href={href} target={target}>
        <div styleName="first-card" style={{ border: columnSeperator || "none" }}>
          {showImageThumbnail && (
            <div styleName="hero-image">
              <HeroImage
                story={story}
                headline={headline}
                aspectRatio={[[4, 3]]}
                iconSizes={{ height: 24, width: 24 }}
                imageUrl={imageUrl}
              />
            </div>
          )}
          {label && <Label story={story} />}
          {headline && <Headline styleName="headline" headline={headline} sectionSlug={sectionSlug} />}

          <PublishAndReadTime showReadTime={showReadTime} showTimestamp={showTimestamp} story={story} />
        </div>
      </Link>
    </div>
  );
};

VerticalStory.propTypes = {
  story: object,
  showThumbnail: bool,
  showReadTime: bool,
  showTimestamp: bool,
  defaultFallback: bool,
  storySeperator: bool,
  columnSeperator: bool,
  sectionSlug: string,
};
